module.exports = __webpack_public_path__ + "static/media/destination-marker.5e6442b0.svg";